<template>
  <img src="/2010/Venue.png" alt="EMBL ATC Heidelberg" class="venue-image" />
  <p>
    VIZBI was one of the very first meetings to be held at EMBL&rsquo;s new
    <a href="http://www.embl.de/training/eicat/atc/">Advanced Training Centre</a> (ATC), located on
    the EMBL Heidelberg campus:
  </p>
  <p>
    Meyerhofstra&szlig;e 1<br />
    69117 Heidelberg<br />
    Germany
  </p>
  <p>
    Information about hotels and transport can be found
    <a
      href="http://www.embl.de/training/events/2010/VIZ10-01/hotel/index.html"
      rel="nofollow"
      title="VENUE"
    >here</a
    >.
  </p>
</template>

<style scoped>
img.venue-image {
  float: right;
  margin: 0 0 12px 12px;
  max-width: 260px;
  width: 40%;
  height: auto;
}
</style>
